import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class JoFooter extends Component {
    render() {
        return (
            <div >
                <a href='' onClick={onUnsubClick} target="_blank">الغاء الاشتراك</a>
            </div>
        );
    }
}

export default JoFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/jofooter.js